// @ts-ignore
import * as hljs from "../../lib/highlight.min.js";
import * as CenteredCarousel from "../modules/centeredCarousel";
import { FeaturedProductSlider }from "../modules/featuredProductSlider";
import * as LoadMore from "../modules/loadMore";
import * as FeaturedRotator from "../modules/featureRotator";
import * as FileInput from "../modules/fileInput";
import * as CategoryStepSlider from "../modules/categoryStepSlider";
import { CategoryNavigation } from "../modules/categoryNavigation";
import * as ProjectQueryResultsSlider from "../modules/projectQueryResults";
import * as ProductQueryResultsSlider from "../modules/productQueryResults";
import * as NavigationSlider from "../modules/navigationSlider";

namespace NHW.controllers.styleGuide {
	function initMarkupToggle() {
		$('.js-markup-toggle').on('click', function() {
			$(this).next('pre').toggleClass('state-visible');
		});
  	}

	function initFieldsToggle() {
		$('.js-fields-toggle').on('click', function() {
			$(this).next('.js-fields').toggleClass('state-visible');
		});
	}

	function simulateLoadIndicator() {
		let $loadIndicator = $('.js-simulate-load-indicator');

		if(!$loadIndicator) {
			return;
		}

		$loadIndicator.on('click', (e) => {
			e.preventDefault();
			let $this = $(this);
			let loadIndicatorItems = $('.js-load-indicator-styleguide');

			loadIndicatorItems.each(function(){
				$(this).removeClass('state-visible');
				$(this).addClass('state-visible');
			});

			setTimeout(function(){
				loadIndicatorItems.each(function(){
					$(this).removeClass('state-visible');
				});
			}, 3000);
		});
	}

	export function init() {
		hljs.initHighlightingOnLoad();
		initMarkupToggle();
		CenteredCarousel.init();
		NavigationSlider.init();
		FeaturedProductSlider.init();
		LoadMore.init();
		simulateLoadIndicator();
		FeaturedRotator.init();
		FileInput.init();
		CategoryStepSlider.init();
		CategoryNavigation.init();
		initFieldsToggle();
		ProductQueryResultsSlider.init();
		ProjectQueryResultsSlider.init();

		$('a[href="#"]').on('click', function (e) {
			e.preventDefault();
    	});
	}
}

NHW.controllers.styleGuide.init();
